import { axios, axios2 } from '@/lib/axios';
export type ResendOtp = {
  email: string;
};

export const resendLawyerOtp = (data: ResendOtp) => {
  return axios2.post(`lawyer-api/lawyer-register-resend`, data);
};
